import {HttpParams} from '@angular/common/http';

export function getBaseLocation() {
    let paths: string[] = location.pathname.split('/').splice(1, 2);
    let basePath;
    if (paths[0] == 'lender'){
        basePath = (paths && paths[1]) || 'ledgersync';
        localStorage.setItem('company', basePath);
        basePath = '/lender/' + basePath;
    } else {
        localStorage.removeItem('company');
    }
    
    return basePath;
}

export const cleanRequest = (dirtyRequest: Record<string, any>): Record<string, any> => {
  const request: Record<string, any> = {};
  Object.keys(dirtyRequest || {}).forEach((key) => {
    const value = dirtyRequest[key];
    if (![null, undefined, ''].includes(value)) {
      request[key] = value;
    }
  });
  return request;
};

export const toHumanReadableLabel = (value: string): string => (value || '')
  .toLowerCase()
  .split('_')
  .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
  .join(' ');

const appendParams = (
  params: HttpParams,
  obj: any,
  prefix: string = ''
): HttpParams => {
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    const paramKey = prefix ? `${prefix}.${key}` : key;

    if (value instanceof Date) {
      params = params.append(paramKey, value.toISOString());
    } else if (value instanceof Array) {
      params = params.append(paramKey, value.join(','));
    } else if (typeof value === 'object' && value !== null) {
      params = appendParams(params, value, paramKey);
    } else if (![null, undefined, ''].includes(value)) {
      params = params.append(paramKey, value);
    }
  });
  return params;
};

export const getHttpParams = (request: Record<string, any>): { params: HttpParams } => {
  const clean = cleanRequest(request);
  let httpParams = new HttpParams();
  httpParams = appendParams(httpParams, clean);
  return { params: httpParams };
};
